import React from 'react';
import PropTypes from 'prop-types';
import { SweepstakesMarkdown } from '../../../utils/SweepstakesMarkdown';
import { SWEEPSTAKES_SURVEY_CONTENT } from '../../../../../core/Data/SweepstakesMockData';
import {
  triggerSweepstakesQualtricsSurvey,
  useSurveyCompletion,
  cleanupQualtricsContent
} from '../../../utils/SweepstakesUtils';
import { windowExists, THDCustomer } from '../../../../../common/utils/AccountUtils';

// Utility functions
const prepareSurveyData = () => ({
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@yopmail.com',
  phone: '1987654321',
  SVOC_ID: THDCustomer().svocID || '',
  USER_ID: THDCustomer().userID || '',
});

const handleSurveyCompletion = () => {
  if (windowExists()) {
    cleanupQualtricsContent();
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('loyalty-benefits.sweepstakes-survey-completed');
  }
};

export const SurveyContent = ({ title, content, heroImage, qualtricsProps }) => {
  const { isOpen, isSurveyDrawerType } = qualtricsProps || {};
  const displayTitle = title || SWEEPSTAKES_SURVEY_CONTENT.title;
  const displayContent = content || SWEEPSTAKES_SURVEY_CONTENT.content;
  const isShowingQualtrics = isOpen && isSurveyDrawerType;

  const handleCompletion = React.useCallback(() => {
    handleSurveyCompletion();
  }, []);

  useSurveyCompletion(handleCompletion, isShowingQualtrics);

  React.useEffect(() => {
    const surveyData = prepareSurveyData();
    triggerSweepstakesQualtricsSurvey({ isOpen: isShowingQualtrics, surveyData });

    if (!isShowingQualtrics) {
      cleanupQualtricsContent();
    }
  }, [isShowingQualtrics]);

  const drawerContent = (
    <div className="sui-grow" data-testid="sweepstakes-survey-content">
      <div id="sweepstakes-qualtrics-survey" className="sui-h-full" />
    </div>
  );

  const footer = null;

  return { content: drawerContent, footer };
};

SurveyContent.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  heroImage: PropTypes.string,
};

SurveyContent.defaultProps = {
  title: null,
  content: null,
  heroImage: null,
};